import { Translations } from './types';

export const de: Translations = {
  // Navigation
  nav: {
    features: 'Funktionen',
    about: 'Über uns',
    pricing: 'Preise',
    support: 'Support',
    admin: 'Admin',
    downloadApp: 'App herunterladen',
  },

  // Hero Section
  hero: {
    title: 'Eine Inspirations-App die du *lieben* wirst',
    subtitle: 'Tägliche Inspiration, KI-generierte Bilder und persönliche Reflexionen für ein motivierteres Leben',
    downloadIOS: 'Download für iOS',
    downloadIOSTestFlight: 'Download für iOS (TestFlight)',
    comingSoonAndroid: 'Bald für Android',
    freeTrialNote: 'Keine Kreditkarte erforderlich • 7 Tage kostenlos testen',
    note: 'Keine Kreditkarte erforderlich • 3 Tage kostenlos testen',
    mockupQuote: 'Der beste Weg, die Zukunft vorherzusagen, ist, sie zu erschaffen.',
    mockupAuthor: '- Peter Drucker',
    playVideo: 'Video abspielen',
  },

  // Quote Example
  quote: {
    example: 'Der beste Weg, die Zukunft vorherzusagen, ist, sie zu erschaffen.',
    author: 'Peter Drucker',
    category: 'Führung & Denkweise',
  },

  // Features Section
  features: {
    title: 'Alles was du für tägliche Inspiration brauchst',
    subtitle: 'Erlebe die komplette Reise der täglichen Inspiration',
    screenshots: {
      categories: {
        title: 'Personalisiere deine Reise',
        description: 'Wähle aus 5 Kategorien, die zu deinen Zielen passen: Tägliche Inspiration, Sport, Führung, Achtsamkeit und Beziehungen.',
      },
      favorites: {
        title: 'Sammle deine Favoriten',
        description: 'Speichere die Zitate, die dich am meisten inspirieren und schaue sie dir an, wann immer du Motivation brauchst.',
      },
      share: {
        title: 'Teile deine Inspiration',
        description: 'Verbreite positive Energie, indem du wunderschön gestaltete Zitatskarten mit Freunden und Familie teilst.',
      },
    },
    feature1: {
      title: 'Tägliche Inspiration',
      description: 'Jeden Tag ein neues motivierendes Zitat aus 5 Kategorien: Inspiration, Sport, Leadership, Achtsamkeit und Beziehungen.',
    },
    feature2: {
      title: 'KI-generierte Bilder',
      description: 'Jedes Zitat wird mit einem einzigartigen, KI-generierten Hintergrundbild präsentiert, das perfekt zur Stimmung passt.',
    },
    feature3: {
      title: 'Persönliche Reflexion',
      description: 'Schreibe deine Gedanken zu jedem Zitat auf und verfolge deine persönliche Entwicklung über Zeit.',
    },
    feature4: {
      title: 'Intelligente Erinnerungen',
      description: 'Erhalte zur perfekten Zeit deine tägliche Inspiration - anpassbar und diskret.',
    },
    feature5: {
      title: 'Mehrsprachig',
      description: 'Verfügbar in Deutsch, Englisch, Spanisch und Französisch - alles automatisch an deine Sprache angepasst.',
    },
    feature6: {
      title: 'Offline-fähig',
      description: 'Deine Inspiration ist immer verfügbar, auch ohne Internetverbindung.',
    },
    dailyInspiration: {
      title: 'Tägliche Inspiration',
      description: 'Jeden Tag ein neues motivierendes Zitat aus 5 Kategorien: Inspiration, Sport, Leadership, Achtsamkeit und Beziehungen.',
    },
    aiImages: {
      title: 'KI-generierte Bilder',
      description: 'Jedes Zitat wird mit einem einzigartigen, KI-generierten Hintergrundbild präsentiert, das perfekt zur Stimmung passt.',
    },
    personalReflection: {
      title: 'Persönliche Reflexion',
      description: 'Schreibe deine Gedanken zu jedem Zitat auf und verfolge deine persönliche Entwicklung über Zeit.',
    },
    smartReminders: {
      title: 'Intelligente Erinnerungen',
      description: 'Erhalte zur perfekten Zeit deine tägliche Inspiration - anpassbar und diskret.',
    },
    multilingual: {
      title: 'Mehrsprachig',
      description: 'Verfügbar in Deutsch, Englisch, Spanisch und Französisch - alles automatisch an deine Sprache angepasst.',
    },
    offline: {
      title: 'Offline-fähig',
      description: 'Deine Inspiration ist immer verfügbar, auch ohne Internetverbindung.',
    },
  },

  // Categories Section
  categories: {
    title: '5 Kategorien für jeden Lebensbereich',
    daily: {
      name: 'Tägliche Inspiration',
      description: 'Motivierende Zitate für jeden Tag',
    },
    sport: {
      name: 'Sport & Disziplin',
      description: 'Motivation für Training und Durchhaltevermögen',
    },
    leadership: {
      name: 'Führung & Denkweise',
      description: 'Führung und unternehmerisches Denken',
    },
    mindfulness: {
      name: 'Achtsamkeit & Balance',
      description: 'Innere Ruhe und Lebensbalance',
    },
    relationships: {
      name: 'Beziehungen & Nähe',
      description: 'Liebe, Freundschaft und zwischenmenschliche Verbindungen',
    },
    inspiration: {
      title: 'Tägliche Inspiration',
      description: 'Motivierende Zitate für deinen Alltag',
    },
    sports: {
      title: 'Sport & Disziplin',
      description: 'Stärke deinen Körper und Geist',
    },
  },

  // Pricing Section
  pricing: {
    title: 'Wähle deinen Plan',
    subtitle: 'Schalte alle Premium-Funktionen frei',
    monthly: {
      title: 'Monatsabo',
      price: '€2,99',
      period: 'pro Monat',
      features: [
        'Tägliche Inspiration',
        'KI-generierte Bilder',
        'Persönliches Journal',
        'Anpassbare Benachrichtigungen',
        'Alle Kategorien',
        'Export-Funktionen',
        'Keine Werbung',
      ],
      cta: 'Monatsabo wählen',
    },
    yearly: {
      title: 'Jahresabo',
      price: '€14,99',
      period: 'pro Jahr',
      badge: 'Beste Wahl',
      features: [
        'Tägliche Inspiration',
        'KI-generierte Bilder',
        'Persönliches Journal',
        'Anpassbare Benachrichtigungen',
        'Alle Kategorien',
        'Export-Funktionen',
        'Keine Werbung',
      ],
      cta: 'Jahresabo wählen',
      savings: 'Spare 58%',
    },
  },

  // Footer
  footer: {
    copyright: 'Alle Rechte vorbehalten.',
    madeWith: 'Mit ❤️ in Deutschland gemacht',
    product: {
      title: 'Produkt',
      features: 'Features',
      pricing: 'Preise',
      admin: 'Admin',
    },
    support: {
      title: 'Support',
      help: 'Hilfe',
      contact: 'Kontakt',
      faq: 'FAQ',
    },
    legal: {
      title: 'Rechtliches',
      privacy: 'Datenschutz',
      terms: 'Nutzungsbedingungen',
      imprint: 'Impressum',
      eula: 'Endbenutzer-Lizenzvereinbarung',
    },
  },
};